import React, { useState } from "react";
import { Row, Col, Card, Menu, Dropdown, Button } from "antd";

import {
  MdEmail,
  MdPhone,
  MdLocationOn,
  BsThreeDotsVertical,
  FaAddressCard,
} from "react-icons/all";
import "./index.css";
import Delete_order from "../../assets/images/delete_order.png";
import CustomModal from "../modals/customModal";
import { useDispatch } from "react-redux";
import { formatToNumber } from "../../config/utils";

export default function PlantInfoCard({
  data,
  getAddresses,
  updateAddress,
  filter,
  isShowDots,
  bussinessName,
  onChangeUpdate,
  isShowAddress,
  onClearErrors,
}) {
  const [isOpenModal, setOpenModal] = useState(false);
  const dispatch = useDispatch();
  const menu = (
    <Menu style={{ width: 0, padding: 0 }} className="menu-fit">
      <Menu.Item
        onClick={() => onChangeUpdate(data, data.address)}
        key="0"
        // onClick={
        //   data?.default_source
        //     ? () => {
        //         info(
        //           "error",
        //           "Cannot delete default card! Make any other card your default and then delete this card"
        //         );
        //       }
        //     : () => setOpenModal(true)
        // }
        style={{ marginLeft: "-5px" }}
      >
        <span className="st-primary">Edit</span>
      </Menu.Item>

      <Menu.Item
        key="0"
        onClick={() => setOpenModal(true)}
        // onClick={
        //   data?.default_source
        //     ? () => {
        //         info(
        //           "error",
        //           "Cannot delete default card! Make any other card your default and then delete this card"
        //         );
        //       }
        //     : () => setOpenModal(true)
        // }
        style={{ marginLeft: "-5px" }}
      >
        <span className="st-primary">Delete</span>
      </Menu.Item>
    </Menu>
  );
  return (
    <Row justify="center">
      <Col xs={24} sm={24} md={24} lg={24} xl={24} className="custom">
        <Card style={{ height: "310px" }} className="ant-card-body card-shadow">
          <Row
            justify="space-between"
            style={{ marginBottom: "10px", marginTop: "20px" }}
          >
            <Col span={!isShowDots ? 12 : 20}>
              <span className="text-right bussinesscard-heading">
                {bussinessName}
              </span>
            </Col>
            {!isShowDots && (
              <Col
                span={12}
                className="text-right"
                style={{ paddingRight: "10px" }}
              >
                <Dropdown
                  overlay={menu}
                  trigger={["click"]}
                  style={{ width: "40%" }}
                >
                  <BsThreeDotsVertical
                    size="20"
                    color="#888888"
                    className="pointer-cursor"
                  />
                </Dropdown>
              </Col>
            )}
          </Row>
          <Row gutter={[0, 2]} justify="space-between">
            <Col span={4} className="text-right ">
              <MdPhone size="20" color="#888888" />
            </Col>
            <Col span={19}>
              <p className="st-primary text-left m-zero information-list">
                Phone
              </p>
              <p className=" text-left three-dot">
                {formatToNumber(data?.phone)}
              </p>
            </Col>
          </Row>
          <Row gutter={[0, 2]} justify="space-between">
            <Col span={4} className="text-right ">
              <MdEmail size="20" color="#888888" />
            </Col>
            <Col span={19}>
              <p className="st-primary text-left m-zero information-list">
                Email
              </p>
              <p className=" text-left three-dot">{data?.email}</p>
            </Col>
          </Row>

          <Row gutter={[0, 2]} justify="space-between">
            <Col span={4} className="text-right ">
              <MdEmail size="20" color="#888888" />
            </Col>
            <Col span={19}>
              <p className="st-primary text-left m-zero information-list">
                Contact Person
              </p>
              <p className=" text-left three-dot">{data?.contact_person ? data?.contact_person : '-'}</p>
            </Col>
          </Row>
          <Row gutter={[0, 2]} justify="space-between">
            <Col span={4} className="text-right ">
              <FaAddressCard size="20" color="#888888" />
            </Col>
            <Col span={19}>
              <p className="st-primary text-left m-zero information-list ">
                Location Name/Label
              </p>
              <p className=" text-left three-dot" title={data?.name}>
                {data?.name || "-"}
              </p>
            </Col>
          </Row>
          <Row gutter={[0, 2]} justify="space-between">
            <Col span={4} className="text-right ">
              <MdLocationOn size="20" color="#888888" />
            </Col>
            <Col span={19}>
              {!isShowAddress && (
                <p className="st-primary text-left m-zero information-list ">
                  Location Address
                </p>
              )}
              <p className=" text-left three-dot" title={data?.address}>
                {data?.address}
              </p>
            </Col>
          </Row>
        </Card>
      </Col>
      <CustomModal
        visible={isOpenModal}
        onCancelModal={() => setOpenModal(false)}
        width={500}
        footer={[
          <Row justify="center" style={{ margin: "20px" }}>
            <Col
              className="d-flex justify-content-center"
              style={{ width: "100%", justifyContent: "space-around" }}
            >
              <Button
                style={{
                  backgroundColor: "#ff9800",
                  color: "#fff",
                  width: "30%",
                  border: "none",
                }}
                onClick={() =>
                  dispatch(
                    updateAddress(data.id, "deactivate", {}, () => {
                      getAddresses(filter);
                      setOpenModal(false);
                    })
                  )
                }
              >
                YES
              </Button>
              <Button
                style={{
                  backgroundColor: "#26a69a ",
                  color: "#fff",
                  width: "30%",
                  border: "none",
                }}
                onClick={() => setOpenModal(false)}
              >
                NO
              </Button>
            </Col>
          </Row>,
        ]}
      >
        <Row justify="center">
          <Col
            className="d-flex justify-content-center"
            span={24}
            style={{ marginTop: "10px" }}
          >
            <img src={Delete_order} width="130px" height={"64px"} />
          </Col>
          <Col
            span={24}
            style={{ textAlign: "center", marginTop: "20px", color: "black" }}
          >
            <span>{"Are you sure you want to delete this card?"}</span>
          </Col>
        </Row>
      </CustomModal>
    </Row>
  );
}
